import en from './en.json';
import da from './da.json';
import sv from './sv.json';

export default {
  en,
  da,
  sv,
};
